// SFX sample manifest — name → { path, gain }.
//
// Assets are expected at public/audio/sfx/{name}.mp3. They DON'T have to exist
// yet: the SFX engine (src/lib/sfx.ts) preloads whatever is present and falls
// back to the synthesized motif for any name whose buffer didn't load. So the
// app ships and sounds correct before the designed assets land; dropping the
// files in later upgrades them with no code change.
//
// `gain` is a per-sound multiplier applied to the sample on its own GainNode
// (mix balance), kept conservative so UI taps stay subtle and the richer
// moments (success / mirrorWake) read louder.

export interface SfxManifestEntry {
  /** Public path served by Vite (file lives in public/audio/sfx/). */
  path: string;
  /** Per-sound mix gain (0–1+). */
  gain: number;
}

export const SFX_MANIFEST: Record<string, SfxManifestEntry> = {
  // Tactile, very short — most frequent, lowest level.
  tap: { path: "/audio/sfx/tap.mp3", gain: 0.5 },
  navigate: { path: "/audio/sfx/navigate.mp3", gain: 0.55 },
  toggle: { path: "/audio/sfx/toggle.mp3", gain: 0.5 },
  // Meaningful moments — richer, a touch louder.
  confirm: { path: "/audio/sfx/confirm.mp3", gain: 0.7 },
  success: { path: "/audio/sfx/success.mp3", gain: 0.8 },
  error: { path: "/audio/sfx/error.mp3", gain: 0.6 },
  // Mirror signatures.
  mirrorWake: { path: "/audio/sfx/mirrorWake.mp3", gain: 0.7 },
  mirrorSpeak: { path: "/audio/sfx/mirrorSpeak.mp3", gain: 0.4 },
};

export type SfxName = keyof typeof SFX_MANIFEST;
